// This file is auto-generated by @hey-api/openapi-ts

import { client, type Options } from '@hey-api/client-fetch'
import type {
  GetApiMinimumsalaryCalculationtypesError,
  GetApiMinimumsalaryCalculationtypesResponse,
  PostApiContractsData,
  PostApiContractsError,
  PostApiContractsResponse,
  GetApiMinimumsalaryFarcalculationtypesError,
  GetApiMinimumsalaryFarcalculationtypesResponse,
  GetApiMinimumsalaryByEditionIdStructureData,
  GetApiMinimumsalaryByEditionIdStructureError,
  GetApiMinimumsalaryByEditionIdStructureResponse,
  PostApiMinimumsalaryByEditionIdCriteriaByCriteriaStructureIdData,
  PostApiMinimumsalaryByEditionIdCriteriaByCriteriaStructureIdError,
  PostApiMinimumsalaryByEditionIdCriteriaByCriteriaStructureIdResponse,
  PostApiMinimumsalaryByEditionIdResultData,
  PostApiMinimumsalaryByEditionIdResultError,
  PostApiMinimumsalaryByEditionIdResultResponse
} from './types.gen'

/**
 * Get calculation types
 */
export const getApiMinimumsalaryCalculationtypes = (options?: Options) => {
  return (options?.client ?? client).get<
    GetApiMinimumsalaryCalculationtypesResponse,
    GetApiMinimumsalaryCalculationtypesError
  >({
    ...options,
    url: '/api/minimumsalary/calculationtypes'
  })
}

/**
 * Get contracts
 */
export const postApiContracts = (options?: Options<PostApiContractsData>) => {
  return (options?.client ?? client).post<PostApiContractsResponse, PostApiContractsError>({
    ...options,
    url: '/api/contracts'
  })
}

/**
 * Get FAR calculation types
 */
export const getApiMinimumsalaryFarcalculationtypes = (options?: Options) => {
  return (options?.client ?? client).get<
    GetApiMinimumsalaryFarcalculationtypesResponse,
    GetApiMinimumsalaryFarcalculationtypesError
  >({
    ...options,
    url: '/api/minimumsalary/farcalculationtypes'
  })
}

/**
 * Get a hierachical list of input criterias which a user will need to select input values for.
 */
export const getApiMinimumsalaryByEditionIdStructure = (
  options: Options<GetApiMinimumsalaryByEditionIdStructureData>
) => {
  return (options?.client ?? client).get<
    GetApiMinimumsalaryByEditionIdStructureResponse,
    GetApiMinimumsalaryByEditionIdStructureError
  >({
    ...options,
    url: '/api/minimumsalary/{editionId}/structure'
  })
}

/**
 * Get a list of possible input values for a given input criteria.
 * This request expect a list with the input criteria values the user already selected.
 * It is possible that you receive an empty result. In this case the user does not need to
 * select anything for this input criteria.
 */
export const postApiMinimumsalaryByEditionIdCriteriaByCriteriaStructureId = (
  options: Options<PostApiMinimumsalaryByEditionIdCriteriaByCriteriaStructureIdData>
) => {
  return (options?.client ?? client).post<
    PostApiMinimumsalaryByEditionIdCriteriaByCriteriaStructureIdResponse,
    PostApiMinimumsalaryByEditionIdCriteriaByCriteriaStructureIdError
  >({
    ...options,
    url: '/api/minimumsalary/{editionId}/criteria/{criteriaStructureId}'
  })
}

/**
 * Based on the given input value the Mindestlohn is calculated.
 * If not all needed input values are given or the combination of values does not make
 * sense an empty result is returned.
 */
export const postApiMinimumsalaryByEditionIdResult = (
  options: Options<PostApiMinimumsalaryByEditionIdResultData>
) => {
  return (options?.client ?? client).post<
    PostApiMinimumsalaryByEditionIdResultResponse,
    PostApiMinimumsalaryByEditionIdResultError
  >({
    ...options,
    url: '/api/minimumsalary/{editionId}/result'
  })
}
